import React, { useRef } from 'react';

import FullCalendar from '@fullcalendar/react';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

import postData from '../../utilities/postData';
import Modal from 'react-bootstrap/Modal';
import SalesAppointmentEditor from '../sales-appointment/SalesAppointmentEditor';
import ActionButton from '../shared/buttons/ActionButton';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DeleteButton from '../shared/buttons/DeleteButton';
import permissionsProvider from '../../utilities/permissionsProvider';

const DesignerCalendar = ({
    appointment,
    cHandler,
    setAppointment,
    setSelectedEvent
}) => {
    const calendarRef = useRef(null);

    const addPt = () => {
        const newPtEvent = {
            id: 0,
            title: 'Personal Time',
            appointmentType: 4
        }
        setAppointment(newPtEvent);
        setSelectedEvent(newPtEvent);
    }

    const deleteAppointment = () => {
        postData(`/api/calendar/delete/personal/${cHandler.selectedEvent.id}`, null, cHandler.resetView);
    }

    const buttons = permissionsProvider.isMinUser('Administrator')
        ? 'addPtButton schedulerDay,customDay,customWeek,customMonth'
        : 'schedulerDay,customDay,customWeek,customMonth';

    const changeCalendarView = (data) => {
        const calendarApi = calendarRef.current.getApi();
        if (calendarApi.view.type === 'customWeek' || calendarApi.view.type === 'customMonth') {
            calendarApi.changeView('schedulerDay', data.date);
        }
    }

    return (
        <div>
            <FullCalendar
                ref={calendarRef}
                schedulerLicenseKey={'0820983039-fcs-1734877181'}
                plugins={[interactionPlugin, resourceTimelinePlugin, dayGridPlugin, timeGridPlugin]}
                selectable={cHandler.selectedEvent}
                initialView="customMonth"
                dateClick={changeCalendarView}
                events={cHandler.events}
                datesSet={(dateInfo) => cHandler.setDates(dateInfo)}
                height={'calc(100vh - 220px)'}
                resources={cHandler.resources}
                resourceAreaWidth={'150px'}
                eventClick={cHandler.eventClick}
                displayEventTime={false}
                select={cHandler.select}
                titleFormat={{ year: 'numeric', month: 'short', day: 'numeric' }}
                navLinks={true}
                themeSystem={'bootstrap'}
                eventDisplay={'block'}
                eventContent={cHandler.formatEvent}
                customButtons={
                    {
                        addPtButton: {
                            text: '+ PTO',
                            click: (addPt)
                        }
                    }
                }
                headerToolbar={
                    {
                        left: 'prev,next today',
                        center: 'title',
                        right: buttons
                    }}
                buttonText={{
                    prev: '<',
                    next: '>',
                    customDay: 'Day',
                    customWeek: 'Week',
                    schedulerDay: 'Scheduler',
                    customMonth: 'Month',
                    today: 'Today'
                }}
                views={cHandler.views}
            />
            {cHandler.selectedEvent && !appointment && (
                cHandler.selectedEvent.appointmentType === 4 ? (
                    <Modal show={true} onHide={cHandler.resetView}>
                        <Modal.Header className="py-1" closeButton>
                            <span className="section-title">
                                Personal Time
                            </span>
                        </Modal.Header>
                        <Modal.Body className="pt-0">
                            <Row className="justify-content-center pt-4">
                                <Col className="d-flex justify-content-center" >
                                    <ActionButton className="no-hide"
                                        buttonText="Reschedule"
                                        imgSource="/images/schedule.svg"
                                        onClick={cHandler.startScheduling}
                                    />
                                    <DeleteButton className="no-hide"
                                        itemName='Personal Time'
                                        onClick={deleteAppointment}
                                    />
                                </Col>
                            </Row>
                        </Modal.Body>
                    </Modal>
                ) : (
                    <Modal size="lg" show={true} onHide={cHandler.resetView}>
                        <Modal.Header className="py-1" closeButton>
                            <span className="section-title">
                                <ActionButton
                                    imgSource="/images/customer_dark.svg"
                                    buttonText={cHandler.selectedEvent.title}
                                        onClick={() => window.location = `/customers/edit/${cHandler.selectedEvent.customerId}`}
                                />
                            </span>
                        </Modal.Header>
                        <Modal.Body className="pt-0">
                            <SalesAppointmentEditor
                                    editId={parseInt(cHandler.selectedEvent.id)}
                                customerId={0}
                                cancelEdit={cHandler.resetView}
                                scheduleOverride={cHandler.startScheduling} />
                        </Modal.Body>
                    </Modal >

                ))}
        </div>
    );
}

export default DesignerCalendar;
